// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"86":"8e7ce7e5","453":"375353c6"}[chunkId] + ".chunk.js";
};